import React from 'react';
import { Link } from 'react-router-dom';
import {
  DropdownToggle, UncontrolledDropdown,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

const TopbarAIService = ({t}) => (
  <UncontrolledDropdown className="topbar__nav-dropdown">
    <DropdownToggle className="topbar__nav-dropdown-toggle">
        <i className="fa fa-binoculars" aria-hidden="true"/>
      <Link to="/aiservice">{t('ai')}</Link>
    </DropdownToggle>
  </UncontrolledDropdown>
);

export default (withTranslation('common')(TopbarAIService));
